import { FC, useState, useEffect } from 'react'
import request from '../../../../services/request'
import { message, Modal } from 'antd'
import { IconButton } from '../..'
import { EyeOutlined } from '@ant-design/icons'

interface IPreviewModal {
    previewUrl?: string
    setDisableSend: (value: boolean) => void
    getPayload: () => Record<string, any>
    disabled?: boolean
}

export const PreviewModal: FC<IPreviewModal> = ({previewUrl, setDisableSend, getPayload, disabled}) => {
    const [pendingPreview, setPendingPreview] = useState<boolean>(false)
    const [previewVisible, setPreviewVisible] = useState(false)
    const [pdfUrl, setPdfUrl] = useState<string | null>(null)

    useEffect(() => {
        return () => {
            if (pdfUrl) {
                URL.revokeObjectURL(pdfUrl)
            }
        }
    }, [pdfUrl])

    const onModalClose = () => {
        setPreviewVisible(false)
        setPdfUrl(null)
    }

    const handlePreview = async () => {
        setDisableSend(true)
        setPendingPreview(true)
        try {
            const payload = getPayload()
            const response = await request.post(
                previewUrl ? previewUrl : '/api/extension/v1/files/certificates/ownership/preview',
                payload,
                {
                    responseType: 'blob',
                },
            )

            const blob = new Blob([response.data], { type: 'application/pdf' })
            const objectUrl = window.URL.createObjectURL(blob)

            setPdfUrl(objectUrl)
            setPreviewVisible(true)
        } catch (error: any) {
            error.text().then((error_text: any) => {
                const text = JSON.parse(error_text)
                console.error('Ошибка при получении PDF:', text)
                message.error(text?.detail)
            })
        } finally {
            setDisableSend(false)
            setPendingPreview(false)
        }
    }

    return (
        <>
            <IconButton
                icon={<EyeOutlined />}
                disabled={disabled}
                onClick={handlePreview}
                customIconStyle={{
                    marginRight: '5px',
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',
                }}
                customStyle={{
                    marginLeft: '16px',
                    padding: '8px 16px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    height: '38px',
                }}
                loading={pendingPreview}
            >
                <span
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        height: '100%',
                        lineHeight: '1.2',
                    }}
                >
                    Предпросмотр
                </span>
            </IconButton>

            <Modal
                visible={previewVisible}
                onCancel={onModalClose}
                footer={null}
                width={900}
                bodyStyle={{
                    width: 900,
                    height: 900,
                    borderRadius: 12,
                    overflow: 'hidden',
                    padding: 0,
                }}
                destroyOnClose
                centered
                closable={false}
            >
                {pdfUrl && (
                    <iframe
                        src={pdfUrl ?? ''}
                        title="Предпросмотр"
                        width="900px"
                        height="900px"
                        style={{ border: 'none' }}
                    />
                )}
            </Modal>
        </>
    )
}
